import { render } from "./CurrentOpenings.vue?vue&type=template&id=a37aadec"
import script from "./CurrentOpenings.vue?vue&type=script&lang=js"
export * from "./CurrentOpenings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__